import { api, refreshAccessToken, waitForPendingRefresh } from "./api";
import { setAccessToken, clearAccessToken } from "./authTokenMemory";
import { pauseRefresh, resumeRefresh } from "./authSessionState";

export const confirmOtp = async (payload) => {
  await waitForPendingRefresh();
  const { data } = await api.post("/auth/login/otp", payload, { skipAuthRefresh: true });
  if (data?.accessToken) {
    resumeRefresh();
    setAccessToken(data.accessToken);
  }
  return data;
};

export const loginUsuario = async (credenciales) => {
  const { data } = await api.post("/auth/usuario/login", credenciales, { skipAuthRefresh: true });
  return data;
};

export const loginPersonal = async (credenciales) => {
  const { data } = await api.post("/auth/personal/login", credenciales, { skipAuthRefresh: true });
  return data;
};

export const refreshAccess = async () => {
  return refreshAccessToken();
};

let logoutPending = null;
export const logout = () => {
  if (!logoutPending) {
    pauseRefresh();
    logoutPending = (async () => {
      try {
        await waitForPendingRefresh();
        await api.post("/auth/logout", {}, { skipAuthRefresh: true });
        clearAccessToken();
      } catch (error) {
        resumeRefresh();
        throw error;
      } finally {
        logoutPending = null;
      }
    })();
  }
  return logoutPending;
};
